module.exports = "/hwa/_next/static/images/skip-exchange-e1aa55319259a26c7e74d90597e155df.png";